'use client';

import { getLanguageFromLocale } from '@bomdisoft/translations';
import s from '@pieleaf/app/[lang]/home/sections/produce-showcase/styles.module.css';
import { ProduceGrid } from '@pieleaf/shared/produce-grid';
import { directFromFarmsNote, produceShowcaseTitle } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export const ProduceShowcaseSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params.lang === 'string' ? params.lang : 'en');

  return (
    <section className={s.section} data-testid='produce-showcase-section'>
      <div className={s.inner}>
        <div className={s.head}>
          <h2 className={s.heading}>{produceShowcaseTitle[language]}</h2>
          <span className={s.note}>{directFromFarmsNote[language]}</span>
        </div>
        <ProduceGrid />
      </div>
    </section>
  );
};
